import './App.css';
import MyCounter from '../components/body/MyCounter';
import Footer from '../components/footer/Footer'


function App() {
  return (
    <div className="App">
      <MyCounter/>
      <Footer/>
    </div>
  );
}

export default App;
